module.exports = __webpack_public_path__ + "img/man-in-car-window.13a189eb.png";